module.exports = __webpack_public_path__ + "img/rob.1b3c591b.png";